import React, {useEffect, useState} from 'react';
import {toastr} from "react-redux-toastr";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import Image from "react-bootstrap/lib/Image";
import Select from 'react-select';
import './style.css';
import {Button} from "react-bootstrap";
import {getDisplaySrc} from "../../utils/commonUtils";
import {confirmOrder, createOrder, fetchCredits} from "./actions";
// import {injectStripe, StripeProvider, Elements} from 'react-stripe-elements';
//
// import _CardForm from '../../components/PurchaseModal/_CardForm';
// import {getPaypalUnits} from "./utils";
//
// const CardForm = injectStripe(_CardForm);

const PurchaseModal = (props) => {

    const [data, setData] = useState([]);
    const [credits, setCredits] = useState(0.00);
    const [tab, setTab] = useState("loading");
    const [order, setOrder] = useState(null);
    const [download_option,set_download_option] = useState('jpg');
    const [download_options, set_download_options] = useState([{value: 'jpg', label: 'JPG'},{value: 'png', label: 'PNG'}, {value: 'pdf', label: 'PDF'}]);

    // const paypalRef = useRef();

    // useEffect(() => {
    //     window.paypal
    //         .Buttons({
    //             createOrder: (data, actions) => {
    //                 triggerOrderCreation("paypal")
    //                     .then(() => actions.order.create({
    //                         purchase_units: getPaypalUnits(data),
    //                     }))
    //                     .catch((err) => {
    //                         console.error(err);
    //                         toastr.error("Oops something went wrong :/");
    //                     })
    //             },
    //             onApprove: async (data, actions) => {
    //                 const paymentDetails = await actions.order.capture();
    //                 triggerOrderConfirmation(paymentDetails);
    //                 toastr.success("Purchase success");
    //             },
    //             onError: err => {
    //                 toastr.error("Oops something went wrong :/");
    //                 console.error(err);
    //             },
    //         })
    //         .render(paypalRef.current);
    // }, [data]);

    useEffect(
        () => {
            window.onmessage = (e) => orderProcessingMessageHandler(e);
        },
        []);


    useEffect(
        () => {
            if (props.show === true) {
                getPremiumResources()
                .then(triggerDownload => {
                    if(triggerDownload){
                        setTab("download")
                    }else{
                        setTab("cart")
                    }
                })
                .catch(() => {
                    toastr.error("Something went wrong :/");
                })
            }
        },
        [props.show]
    );

    useEffect(() => {
        console.log('animation status ---> ', window.design_editor.design.isAnimated());
        if (props.show && window.design_editor.design.isAnimated()) {
            set_download_options([{value: 'jpg', label: 'JPG'},{value: 'png', label: 'PNG'}, {value: 'pdf', label: 'PDF'}, { value: 'mp4', label: 'MP4' }]);
        } else {
            set_download_options([{value: 'jpg', label: 'JPG'},{value: 'png', label: 'PNG'}, {value: 'pdf', label: 'PDF'}]);
        }
    }, [ props.show ]);

     const orderProcessingMessageHandler = (e) => {
        if (e.data == 'orderPaymentSuccess') {
            props.hideUnifiedCheckoutModal();
            handleDesignDownload();
        }
        else if (e.data == 'orderPaymentFailure') {
            props.hideUnifiedCheckoutModal();
            toastr.error("Something went wrong :/");
        }
    };

    const handleDesignDownload = async () => {
        window.document.getElementById('overlay_button_download').click();
        await window.design_editor.design.handlePurchaseRedraw(data);
        setTab("download");
        // props.export_design();
    };

    const fetchDesignResources = (resources) => {

        let requestPayload = {
            id: resources.map(x => x.id)
        };

        return [
            fetch(global.config.server_path + 'design_resource/get/', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                'credentials': 'include',
                body: JSON.stringify(requestPayload)
            })
                .then(resp => resp.json())
                .then(data => {
                    data = data.data.docs;
                    let premiumDesignResources = data.filter(x => x['free'] !== true)
                        .map(x => {
                            return {id: x._id, resource_type: 'design_resource', src: x.src}
                        });
                    return Promise.resolve(premiumDesignResources);
                })
                .catch(err => {
                    console.error(err);
                    toastr.error("Oops something went wrong :/");
                    return Promise.reject("Failed to fetch design resources");
                })
        ];
    };


    const fetch123RfResources = (resources) => {
        let promiseArray = [];
        for (let i = 0; i < resources.length; i++) {
            promiseArray.push(fetch(global.config.server_path + 'design_resource/load_123rf_resource/', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                'credentials': 'include',
                body: JSON.stringify({
                    design_id: props.designId,
                    id: resources[i].id
                })
            })
                .then(data => data.json())
                .then(data => Promise.resolve({
                    id: resources[i].id,
                    src: data.data.src,
                    'resource_type': '123rf_image'
                }))
                .catch(err => Promise.resolve({
                    id: resources[i].id,
                    src: null,
                    'resource_type': '123rf_image'
                })))
        }
        return promiseArray;
    };

    const fetch123RfPlusResources = (resources) => {
        let promiseArray = [];
        for (let i = 0; i < resources.length; i++) {
            promiseArray.push(fetch(global.config.server_path + 'design_resource/load_123rf_plus_resource/', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                'credentials': 'include',
                body: JSON.stringify({
                    design_id: props.designId,
                    id: resources[i].id
                })
            })
                .then(data => data.json())
                .then(data => Promise.resolve({
                    id: resources[i].id,
                    src: data.data.src,
                    'resource_type': '123rf_plus_image'
                }))
                .catch(err => Promise.resolve({
                    id: resources[i].id,
                    src: null,
                    'resource_type': '123rf_plus_image'
                })))
        }
        return promiseArray;
    };

    const fetchPixlrResources = (resources) => {
        let promiseArray = [];
        for (let i = 0; i < resources.length; i++) {
            promiseArray.push(fetch(global.config.server_path + 'design_resource/load_pixlr_resource/', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                'credentials': 'include',
                body: JSON.stringify({
                    design_id: props.designId,
                    id: resources[i].id
                })
            })
                .then(data => data.json())
                .then(data => Promise.resolve({
                    id: resources[i].id,
                    src: data.data.src,
                    'resource_type': 'pixlr_image'
                }))
                .catch(err => Promise.resolve({
                    id: resources[i].id,
                    src: null,
                    'resource_type': 'pixlr_image'
                })))
        }
        return promiseArray;
    };


    const trigger_download = () => { 
        window.document.getElementById('overlay_button_download').click();
        props.export_design(download_option);
    }


    const getPremiumResources = async () => {

        try {
            let resourcesInDesign = window.design_editor.design.getAllResources();

            let premiumResourcesInDesign = await fetch(global.config.server_path + 'design_resource/get_premium_resources', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                'credentials': 'include',
                body: JSON.stringify({design_id: props.designId, resources: resourcesInDesign})
            });

            premiumResourcesInDesign = await premiumResourcesInDesign.json();

            let premiumDesignResources = premiumResourcesInDesign.data.filter(x => x.type === 'design_resource');
            let premium123RfResources = premiumResourcesInDesign.data.filter(x => x.type === '123rf');
            let premium123RfPlusResources = premiumResourcesInDesign.data.filter(x => x.type === '123rf_plus');
            let premiumPixlrResources = premiumResourcesInDesign.data.filter(x => x.type === 'pixlr');

            let dataPromises = [];
            dataPromises = dataPromises.concat(fetchDesignResources(premiumDesignResources));
            dataPromises = dataPromises.concat(fetch123RfResources(premium123RfResources));
            dataPromises = dataPromises.concat(fetch123RfPlusResources(premium123RfPlusResources));
            dataPromises = dataPromises.concat(fetchPixlrResources(premiumPixlrResources));
            let creditDetails = fetchUserCredits();

            let premiumResourcesData = [];

            let resources = await Promise.all(dataPromises);

            for (let i = 0; i < resources.length; i++) {
                if (Array.isArray(resources[i])) {
                    premiumResourcesData = premiumResourcesData.concat(resources[i])
                } else {
                    premiumResourcesData.push(resources[i])
                }
            }

            setData(premiumResourcesData);
            await creditDetails;
            return premiumResourcesData.length === 0;
        } catch (err) {
            console.error(err);
            toastr.error("Something went wrong :/");
        }
    };



    const fetchUserCredits = async () => {
        try {
            let credits = await fetchCredits();
            if (credits.response_code === 1) setCredits(credits['data']['123rf']['remaining']);
        } catch (e) {
            toastr.error("Error fetching credits");
            return Promise.reject(e);
        }
    };

    const handlePurchase = async () => {
        if (credits > data.length) {
            await triggerOrderCreation("credits");
            handleDesignDownload();
        } else {
            props.hide();
            let orderDetails = await triggerOrderCreation("stripe");
            if (orderDetails && orderDetails.checkoutUrl) {
                window.location.href = orderDetails.checkoutUrl;
                // props.showUnifiedCheckoutModal(orderDetails.checkoutUrl);
            }
            else {
                toastr.error("Something went wrong :/");
            }
            // setTab('payment');
        }
    };

    const triggerOrderCreation = async (paymentMode) => {
        try {
            setTab("loading");
            let orderDetails = await createOrder({paymentMode: paymentMode, data: data, designId: props.designId});
            setOrder(orderDetails);
            setTab("cart");
            return orderDetails;
        } catch (e) {
            console.error(e);
            setTab("cart");
            toastr.error("Oops something went wrong :/");
        }
    };

    const triggerOrderConfirmation = async (paymentDetails) => {
        return await confirmOrder({id : order['_id'], paymentDetails});
    };

    const triggerStripeOrderConfirmation = async (paymentDetails) => {
        try {
            let confirmedOrder = await confirmOrder({id : paymentDetails.metadata.orderId, paymentDetails});
            handleDesignDownload();
            return confirmedOrder;
        } catch (e) {
            console.error(e);
        }
    };

    if (tab === 'loading') {
        return (
            <div className="purchase-modal-container-inner">
                <Image style={{height : '50px', width: '50px',marginLeft:'calc(50% - 25px)'}} src={global.config.server_path+"public/images/loader.gif"} />
            </div>
        );
    }

    if (tab === 'cart') {
        return (
            <div className="purchase-modal-container-inner">
                {data.length ?
                        (<React.Fragment>
                            <div className="download-popover-header">
                                <i className="fas fa-download fa-lg"/>
                                <span
                                    style={{'fontWeight': 600, 'fontSize': '1.4rem', 'paddingLeft': 10}}>Download</span>
                            </div>
                            <Row className="text-center" style={{padding: '10px 0px'}}>
                                {data.map(x => {
                                    return (
                                        <React.Fragment>
                                            <Col xs={4} style={{paddingLeft: 0}}>
                                                <Image style={{height: 60, border: 'solid 1px #fafafa'}}
                                                       src={getDisplaySrc(x)}/>
                                            </Col>
                                            <Col xs={8} style={{height: 60, display: 'table'}}>
                                                <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
                                                    <span style={{float: 'right', fontWeight: 400, fontSize: '1.4rem'}}>$ 1.00 or 1 credit</span>
                                                </div>
                                            </Col>
                                        </React.Fragment>
                                    )
                                })}
                            </Row>
                            <Row style={{borderTop: '1px solid #CCCCCC', padding: '10px 0px'}}>
                                <span
                                    style={{fontWeight: 400, fontSize: '1.4rem'}}>{data.length} X Premium Images</span>
                                <span style={{float: 'right', fontWeight: 600, fontSize: '1.4rem'}}> ${data.length}.00 or {data.length} credits</span>
                            </Row>
                            <Row>
                                <span style={{fontWeight: 400, fontSize: '1.4rem'}}>Credits available</span>
                                <span style={{float: 'right', fontWeight: 600, fontSize: '1.4rem'}}>{credits}</span>
                            </Row>
                            <Row style={{padding: '10px 0px'}}>
                                <Button className="btn-orange" style={{width: "100%", marginBottom: 5}}
                                        onClick={handlePurchase}> {credits > data.length?('Download with no watermarks ('+data.length+ ' credit'+(data.length === 1?'':'s') + ')'):'Buy now and download'}</Button>
                                <Button className="btn-grey" style={{width: "100%"}} onClick={e => setTab("download")}>Download with watermarks</Button>
                            </Row>
                        </React.Fragment>) : null
                    }
            </div>
        )
    } else {
        return (
            <div className="purchase-modal-container-inner">
                <div className="download-popover-header">
                    <i className="fas fa-download fa-lg"/>
                    <span
                        style={{'fontWeight': 600, 'fontSize': '1.4rem', 'paddingLeft': 10}}>Download</span>
                </div>
                <Row className="text-center" style={{padding: '10px 0px'}}>
                    <Col xs={12} style={{paddingLeft: 0}}>
                        <Select options={download_options} value={download_options.find(o => o.value==download_option)} onChange={(e)=>{set_download_option(e.value)}}/>
                    </Col>
                </Row>
                
                <Row style={{padding: '10px 0px'}}>
                    <Button className="btn-orange" style={{width: "100%"}} onClick={trigger_download}>Download</Button>
                </Row>
                     
            </div>
        );
    }
};

export default PurchaseModal;